<div class="std-empty-state">
  <svg class="width-3p125 height-3p125 opacity0p64 entered-row-container flex00auto">
    <use [attr.xlink:href]="iconName + '#img'" [attr.href]="iconName + '#img'"></use>
  </svg>
  <span class="centered-column-container opacity0p64 column-gap-0p5">
    <span *ngIf="heading" class="{{titleClass}} bold600">{{ heading }}</span>
    <span *ngIf="description" class="font-3">{{ description }}</span>
  </span>
  <div *ngIf="!useTwoButtons">
    <app-button
      *ngIf="isAdmin && !buttonIconName"
      data-qa="empty-state-button"
      [size]="'small'"
      [type]="'accent'"
      (buttonClick)="buttonClick.emit()"
    >
      {{ buttonText }}
    </app-button>
    <app-button
      *ngIf="isAdmin && buttonIconName"
      data-qa="empty-state-button"
      [size]="'small'"
      [type]="'accent'"
      [iconName]="buttonIconName"
      (buttonClick)="buttonClick.emit()"
    >
      {{ buttonText }}
    </app-button>
  </div>
  <div *ngIf="useTwoButtons" class="start-row-container row-gap-0p375">
    <app-button
      *ngIf="isAdmin && !buttonIconName"
      data-qa="empty-state-button"
      [size]="'small'"
      [type]="'accent'"
      (buttonClick)="buttonClick.emit()"
    >
      {{ buttonText }}
    </app-button>
    <app-button
      *ngIf="isAdmin && buttonIconName"
      data-qa="empty-state-button"
      [size]="'small'"
      [type]="'accent'"
      [iconName]="buttonIconName"
      (buttonClick)="buttonClick.emit()"
    >
      {{ buttonText }}
    </app-button>
    <app-button
      *ngIf="isAdmin && !buttonIconName"
      data-qa="empty-state-button"
      [size]="'small'"
      [type]="'accent'"
      (buttonClick)="secondButtonClick.emit()"
    >
      {{ secondButtonText }}
    </app-button>
    <app-button
      *ngIf="isAdmin && buttonIconName"
      data-qa="empty-state-button"
      [size]="'small'"
      [type]="'accent'"
      [iconName]="secondButtonIconName"
      (buttonClick)="secondButtonClick.emit()"
    >
      {{ secondButtonText }}
    </app-button>
  </div>
</div>
